import { computed, watch } from "vue";
import { store } from "@/store";

import WebFont from "webfontloader";

import fontData from "@/data/fonts.json";

let fontsAreLoaded = false;

const fonts = Object.values(fontData);

const mountingLabel = computed(() => store.getters.mountingLabel);

watch(mountingLabel, async (newState) => {
  if (!newState && !fontsAreLoaded) {
    const chunks = [];
    const numOfFontsPerLoop = 20;
    const remaining = fonts.length % numOfFontsPerLoop;

    while (fonts.length > remaining) {
      chunks.push(fonts.splice(0, numOfFontsPerLoop));
    }
    chunks.push(fonts);

    const loadFontsIncrementally = (fonts) => {
      return new Promise((resolve) => {
        WebFont.load({
          google: {
            families: fonts,
          },
          active: function() {
            resolve();
          },
        });
      });
    };

    for await (const chunk of chunks) {
      await loadFontsIncrementally(chunk);
    }

    fontsAreLoaded = true;
  }
});
